import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductionFeatureDefinition } from '@digiwall/goliath-products/config';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'folder-docs' },
  {
    path: 'folder-docs',
    title: 'Doc::Menu:ProductionFolderDocs',
    canMatch: [ProductionFeatureDefinition],
    data: {
      breadcrumb: {} as BreadcrumbDefinition,
    },
    loadChildren: () =>
      import('./production-folder-doc/production-folder-doc.module').then(
        m => m.ProductionFolderDocModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductionRoutingModule {}
